import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { GetMemberResponse } from '@modules/company-manager/clients/domain';
import { GetUserDetailsResponse } from '@modules/company-manager/users/domain';
import { API_ENDPOINTS } from '@typings/api-endpoints.type';
import { map, Observable, of } from 'rxjs';
import {
  ChangePasswordParams,
  GetProfileResponse,
  updateProfile,
} from '../../domain/entities/profile.entity';
import { ProfileServices } from '../../domain/services/profile.service';

@Injectable()
export class ProfileServicesImpl implements ProfileServices {
  constructor(private client: HttpClient) {}

  updateProfileData(data: updateProfile, memberId: string): Observable<any> {
    return this.client
      .patch<GetMemberResponse>(
        environment.apiDomain + API_ENDPOINTS.MEMBER.UPDATE(memberId),
        data
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  updatePassword(
    userData: ChangePasswordParams
  ): Observable<GetUserDetailsResponse> {
    return this.client
      .patch<GetUserDetailsResponse>(
        environment.apiDomain +
          API_ENDPOINTS.USERS.CHANGE_PASSWORD(userData.userId),
        {
          password: userData.newPassword,
          oldPassword: userData.oldPassword,
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  updatePhoto(photo: any, userId: string): Observable<any> {
    const params = new HttpParams().set('populate', '_profilePicture');

    const requestBody = new FormData();
    requestBody.append('file', photo);
    return this.client
      .patch<any>(
        environment.apiDomain + API_ENDPOINTS.USERS.UPDATE_PHOTO(userId),
        requestBody,
        { params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}
